import { userInfoStore } from './userInfo';
import { MemberInfo } from '../types';
import { EventBasedStore } from '../utils/EventBasedStore';
import { getResultFromResponse, runAsyncSafe } from '@web3/utils';
import { getMemberInfo } from '../api';

export class MemberInfoStore extends EventBasedStore<{
  memberInfo?: MemberInfo;
}> {
  constructor() {
    super({}, undefined, () => {
      this.getMemberInfo();
      userInfoStore.on('update', () => {
        this.getMemberInfo();
      });
    });
  }

  async getMemberInfo() {
    const { isLogin, userInfo } = userInfoStore.state;
    if (!isLogin || this.state.memberInfo?.memberId === String(userInfo?.id ?? '')) {
      return;
    }
    const [, data] = await runAsyncSafe(getResultFromResponse(getMemberInfo()));
    this.setState({
      memberInfo: data ?? undefined,
    });
  }
}
export const memberInfoStore = new MemberInfoStore();
